import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * Automatically scrolls to top of page on route change
 * Also resets CSS variables and body styles to prevent FOUC
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  // Reset styles synchronously before paint to prevent flash
  useLayoutEffect(() => {
    // Reset all CSS variables that might have been set by previous pages
    const root = document.documentElement;
    const cssVariables = [
      '--terms-bg', '--terms-text', '--terms-text-heading', '--terms-accent', '--terms-accent-muted', '--terms-border',
      '--terms-card-bg', '--terms-card-text', '--terms-card-text-muted',
      '--privacy-bg', '--privacy-text', '--privacy-text-heading', '--privacy-accent', '--privacy-accent-muted', '--privacy-border',
      '--privacy-card-bg', '--privacy-card-text', '--privacy-card-text-muted',
      '--transparency-bg', '--transparency-text', '--transparency-text-heading', '--transparency-accent', '--transparency-accent-muted', '--transparency-border',
      '--transparency-card-bg', '--transparency-card-text', '--transparency-card-text-muted',
      '--security-bg', '--security-text', '--security-text-heading', '--security-accent', '--security-accent-muted', '--security-border',
      '--security-card-bg', '--security-card-text', '--security-card-text-muted'
    ];
    
    cssVariables.forEach(varName => {
      root.style.removeProperty(varName);
    });

    // Reset body styles to default (pages will set their own if needed)
    document.body.style.background = '';
    document.body.style.color = '';
    document.body.style.backgroundColor = '';
  }, [pathname]);

  useEffect(() => {
    // Scroll to top immediately when route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use 'instant' for immediate scroll, 'smooth' for animated
    });
  }, [pathname]);

  return null;
}

export default ScrollToTop;

